/** Mobile-safe field sizing and keyboards.
 *  16px text stops iOS zooming on focus, 44px height keeps the control thumb-friendly,
 *  and the desktop sizes are unchanged from `sm` up.
 */
export const FIELD_CLASS = 'h-11 text-base sm:h-10 sm:text-sm';

export const EMAIL_PROPS = {
  type: 'email',
  inputMode: 'email',
  autoComplete: 'email',
  autoCapitalize: 'none',
  autoCorrect: 'off',
  spellCheck: false,
};

export const TEL_PROPS = {
  type: 'tel',
  inputMode: 'tel',
  autoComplete: 'tel',
};
